<template>
  <div>
  </div>
</template>

<script>
import UsersApi from '@/services/UsersApi';
export default {
  created: () => {
    document.title = 'ThinkSpatial | Gateway';
  },  
  mounted() {
    UsersApi.xeroCredentials(this.$route.query)
    .then((response) => {
      console.log(response)
      // Now to check for MS Graph Oauth
      console.log('MSAL.js');
      this.$router.push({ name: 'dashboard'});
    });
  }
}
</script>

<style>

</style>